import { useDispatch, useSelector } from "react-redux";
import { selectShipmentBills, selectShipmentBillsUploadStatus, setUnauthorized, uploadShipmentBills } from "./shipmentBillsSlice";
import { useEffect, useState } from "react";
import Bill from "./Bill";
import { requireAuthentication } from "../authentication/authSlice";
import GreenSpinner from "../../components/loaders/GreenSpinner";
import { useTranslation } from "react-i18next";

const ShipmentBills = () => {
    const {t} =  useTranslation()
    const dispatch = useDispatch();
    const shipmentBills = useSelector(selectShipmentBills);
    const unauthorized = useSelector(state => state.shipmentBills.unauthorized)
    const status = useSelector(selectShipmentBillsUploadStatus)

    const [selectedTrc, setSelectedTrc] = useState("");

    useEffect(() => {
        dispatch(uploadShipmentBills());
    }, [dispatch]);

    useEffect(() => {
        if(unauthorized) {
            dispatch(requireAuthentication(false))
            dispatch(setUnauthorized(false))
        }
    }, [dispatch, unauthorized])

    useEffect(() => {
        if(shipmentBills?.length > 0) {
            const arr = window.location.href.split("#")
            if(arr.length < 2) {
                return
            }

            setSelectedTrc(arr[1])
        }
    }, [shipmentBills])

    return (
    <div className="block w-full border mx-auto p-4 shadow-2xl rounded-xl">
        <header className="text-center font-medium mb-4">
            {(!shipmentBills || shipmentBills.length === 0) && status !== "pending" && t("bills.bills_list.bills_not_found")}
            {status === "pending" && <div className="px-5 py-3">
                    {t("bills.bills_list.uploading")} {" "}
                    <GreenSpinner />
                </div>
            }
            {(shipmentBills && shipmentBills.length > 0) && t("bills.bills_list.title")}
        </header>
        
        <div className="flex flex-col justify-center items-center gap-4">
            {
                shipmentBills?.map((shipmentBill) => (
                    <Bill key={shipmentBill.id} bill={shipmentBill} selectedTrc={selectedTrc}/>
                ))
            }
        </div>
    </div>
    );
};

export default ShipmentBills;
